<template>
  <v-form ref="form" @submit.prevent="submitForm" v-model="valid">
    <v-card class="mx-auto EK-card rounded-xl rounded-tr-0 IMThemeGray text-right pb-5">
      <v-card-text>
        <v-col>
            <v-row>
                <v-col cols="12" md="6">
                    <label for="facebookLink" style="color: #f5df4d">
                        <img src="/media/svg/pen-notification.svg"
                             width="24"
                             class="ml-2"
                             alt="pen" />فيسبوك
                    </label>
                    <v-text-field v-model="about.facebookLink"
                                  class="rounded-tr-0"
                                  id="facebookLink"
                                  :rules="link"
                                  dense
                                  rounded
                                  dir="ltr"
                                  solo></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <label for="email" style="color: #f5df4d">
                        <img src="/media/svg/pen-notification.svg"
                             width="24"
                             class="ml-2"
                             alt="pen" />البريد الالكتروني
                    </label>
                    <v-text-field v-model="about.email"
                                  class="rounded-tr-0"
                                  id="email"
                                  :rules="email"
                                  dense
                                  rounded
                                  dir="ltr"
                                  solo></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <label for="title" style="color: #f5df4d">
                        <img src="/media/svg/pen-notification.svg"
                             width="24"
                             class="ml-2"
                             alt="pen" />العنوان
                    </label>
                    <v-text-field v-model="about.address"
                                  class="rounded-tr-0"
                                  id="address"
                                  :rules="address"
                                  dense
                                  rounded
                                  solo></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <label for="title" style="color: #f5df4d">
                        <img src="/media/svg/pen-notification.svg"
                             width="24"
                             class="ml-2"
                             alt="pen" />رقم الموبايل
                    </label>
                    <v-text-field v-model="about.mobileNumber"
                                  class="rounded-tr-0"
                                  id="mobileNumber"
                                  :rules="mobileNumber"
                                  dense
                                  rounded
                                  solo></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <label for="title" style="color: #f5df4d">
                        <img src="/media/svg/pen-notification.svg"
                             width="24"
                             class="ml-2"
                             alt="pen" />رقم الهاتف
                    </label>
                    <v-text-field v-model="about.phoneNumber"
                                  class="rounded-tr-0"
                                  id="phoneNumber"
                                  :rules="phoneNumber"
                                  dense
                                  rounded
                                  solo></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <label for="instagram" style="color: #f5df4d">
                        <img src="/media/svg/pen-notification.svg"
                             width="24"
                             class="ml-2"
                             alt="pen" />انستاغرام
                    </label>
                    <v-text-field v-model="about.instagramLink"
                                  class="rounded-tr-0"
                                  id="instagram"
                                  :rules="link"
                                  dense
                                  rounded
                                  solo
                                  dir="ltr"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <label for="telegram" style="color: #f5df4d">
                        <img src="/media/svg/pen-notification.svg"
                             width="24"
                             class="ml-2"
                             alt="pen" />تلغرام
                    </label>
                    <v-text-field v-model="about.telegramLink"
                                  class="rounded-tr-0"
                                  id="telegram"
                                  :rules="link"
                                  dense
                                  rounded
                                  solo
                                  dir="ltr"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <label for="telegram" style="color: #f5df4d">
                        <img src="/media/svg/pen-notification.svg"
                             width="24"
                             class="ml-2"
                             alt="pen" />Whatsapp
                    </label>
                    <v-text-field v-model="about.whatsappLink"
                                  class="rounded-tr-0"
                                  id="telegram"
                                  :rules="link"
                                  dense
                                  rounded
                                  solo
                                  dir="ltr"></v-text-field>
                </v-col>
                <v-row>
                    <v-col  v-if="about.allowed"  cols="12" lg="6">
                        <label for="shopsCount" style="color: #f5df4d">
                            <img src="/media/svg/pen-notification.svg"
                                 width="24"
                                 class="ml-2"
                                 alt="pen" />عدد المستفيدين
                        </label>
                        <v-text-field v-model="about.usersCount"
                                      class="rounded-tr-0"
                                      id="shopsCount"
                                      type="number"
                                      dense
                                      rounded
                                      solo
                                      dir="ltr"
                                      messages="عند اختيار الرقم 0 يتم الاستبدال بعدد المستفيدين الأصلي"></v-text-field>
                    </v-col>
                    <v-col  v-if="about.allowed" cols="12" lg="6">
                        <label for="shopsCount" style="color: #f5df4d">
                            <img src="/media/svg/pen-notification.svg"
                                 width="24"
                                 class="ml-2"
                                 alt="pen" />عدد المشتركين
                        </label>
                        <v-text-field v-model="about.shopsCount"
                                      class="rounded-tr-0"
                                      id="shopsCount"
                                      type="number"
                                      dense
                                      rounded
                                      solo
                                      dir="ltr"
                                      messages="عند اختيار الرقم 0 يتم الاستبدال بعدد المشتركين الأصلي"></v-text-field>
                    </v-col>
                </v-row>
                <v-col cols="12">
                    <label for="description" style="color: #f5df4d">
                        <img src="/media/svg/document-notification.svg"
                             width="24"
                             class="ml-2"
                             alt="pen" />الوصف
                    </label>
                    <v-textarea v-model="about.description"
                                class="rounded-tr-0"
                                color="secondary"
                                id="description"
                                :rules="description"
                                rounded
                                solo></v-textarea>
                </v-col>
            </v-row>
        </v-col>
      </v-card-text>
      <v-card-actions class="justify-content-center">
        <v-btn type="submit" rounded class="by-5 px-10 rounded-tr-0" :disabled="!valid">
          تم
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<style >
.v-messages__message{
    color: white;
}
</style>
<script>
export default {
  data: () => ({
    valid: false,
    description: [(v) => !!v || "هذا الحقل إجباري", (v) => v && v.length >= 10],
    link: [
      (v) =>
        !!!v ||
        /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/.test(
          v
        ) ||
        "يرجى وضع رابط صحيح متضمناً (http)",
    ],
    email: [
      (v) =>
        !!!v ||
        /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
          v
        ) ||
        "يرجى كتابة إيميل صحيح",
    ],
    address: [(v) => !!v || "هذا الحقل إجباري"],
    mobileNumber: [
      (v) => !!v || "هذا الحقل إجباري",
      (v) => (v && v.length >= 10 && /^[0-9]+$/.test(v)) || "يرجى كتابة رقم موبايل صحيح ",
    ],
    phoneNumber: [
      (v) => !!v || "هذا الحقل إجباري",
      (v) => (v && v.length >= 6 && /^[0-9]+$/.test(v)) || "يرجى كتابة رقم هاتف صحيح ",
    ],
  }),

  props: {
    about: Object,
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submitForm() {
      this.$store.dispatch("setAbout", this.about);
      this.close();
    },
  },
};
</script>
